module.exports = __webpack_public_path__ + "static/media/step-04.c682135c.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/montemar-adelantos/img/step-04.png
 ** module id = 1366
 ** module chunks = 0
 **/